import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { FormValidationService } from "src/app/core/services/form-validation.service";
import { CustomerLoginRequest } from "src/app/shared/models/DTO/CustomerLoginRequest.dto";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-about-me-login",
	templateUrl: "./about-me-login.component.html",
	styleUrls: ["../../customer.scss"],
})
export class AboutMeLoginComponent implements OnInit {
	@Output() customerKeyChange = new EventEmitter<string>();

	awaitValidation: boolean = false;

	controlEmailField: UntypedFormControl;
	controlPhoneField: UntypedFormControl;
	customerKey: string;

	emailValue: string;

	infoMessage: string = undefined;

	phoneValue: string;

	searchMethod: string = "email";

	validationCode: string;

	constructor(
		public app: AppService,
		private formValidationService: FormValidationService,
		private focuslink: FocuslinkService,
		private activatedRoute: ActivatedRoute
	) {}

	ngOnInit(): void {
		this.customerKey = this.activatedRoute.snapshot.queryParamMap.get("ck");
		this.validationCode = this.activatedRoute.snapshot.queryParamMap.get("vc");

		if (this.customerKey && this.validationCode) {
			this.awaitValidation = true;
		} else {
			this.controlEmailField = new UntypedFormControl(this.emailValue, [Validators.email]);
			this.controlPhoneField = new UntypedFormControl(this.phoneValue, [this.formValidationService.phoneValueValidate()]);
		}
	}

	async onRequestValidationCode() {
		if (this.searchMethod === "phone") {
			this.app.loading(true);
		}

		const loginRequest: CustomerLoginRequest = {
			method: this.searchMethod,
			value: this.searchMethod === "email" ? this.emailValue : this.app.references.phoneToformatE164(this.phoneValue).replace("+1", ""),
		};

		try {
			const resp = await this.focuslink.customerLogin(loginRequest);
			this.customerKey = resp.ck;
			this.app.loading(false);
			this.infoMessage = this.searchMethod === "email" ? `You will receive an email shortly with a link to login.` : undefined;
			this.awaitValidation = true;
		} catch (error) {
			this.app.loading(false);
			this.app.msgSvc.add({
				severity: AppMessageSeverity.RED,
				summary: "",
				detail: `Sorry, there was a problem validating your account \n ${error.error.error}`,
			});
			this.infoMessage = `Sorry, there was a problem validating your account \n ${error.error.error}`;
		}
	}

	onValidationResponse(state: boolean) {
		if (state) {
			this.customerKeyChange.emit(this.customerKey);
		} else {
			this.customerKey = undefined;
			this.validationCode = undefined;
			this.phoneValue = undefined;
			this.emailValue = undefined;
			this.controlEmailField = new UntypedFormControl(this.emailValue, [Validators.email]);
			this.controlPhoneField = new UntypedFormControl(this.phoneValue, [this.formValidationService.phoneValueValidate()]);
		}
	}
}
